var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5422_19532",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5422_19532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00391 15.999H14.0039V13.999H6.00391V15.999ZM6.00391 11.999H18.0039V9.99902H6.00391V11.999ZM4.00391 19.999C3.45391 19.999 2.98307 19.8032 2.59141 19.4115C2.19974 19.0199 2.00391 18.549 2.00391 17.999V5.99902C2.00391 5.44902 2.19974 4.97819 2.59141 4.58652C2.98307 4.19486 3.45391 3.99902 4.00391 3.99902H10.0039L12.0039 5.99902H20.0039C20.5539 5.99902 21.0247 6.19486 21.4164 6.58652C21.8081 6.97819 22.0039 7.44902 22.0039 7.99902V17.999C22.0039 18.549 21.8081 19.0199 21.4164 19.4115C21.0247 19.8032 20.5539 19.999 20.0039 19.999H4.00391ZM4.00391 17.999H20.0039V7.99902H11.1789L9.17891 5.99902H4.00391V17.999Z",
    fill: "#2D2F31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogicon);
export default __webpack_public_path__ + "static/media/Catalogicon.c4effd1d6aeffb2f54b7ca352e33352e.svg";
export { ForwardRef as ReactComponent };